/**
 * CTR Buy Button – add-to-cart & buy-once logic.
 *
 * Price updates come from the ctr:price-update event dispatched by ctr-price-new.js.
 * Fallback: hidden variant-input mutation observer (if ctr-price-new.js is absent).
 */
(function () {
  var wrapper = document.querySelector('[data-ctr-buy-button]');
  if (!wrapper) return;

  var buyOnceBtn    = wrapper.querySelector('[data-ctr-buy-once]');
  var productDataEl = wrapper.querySelector('[data-ctr-buy-button-product]');
  var productData   = productDataEl ? JSON.parse(productDataEl.textContent) : null;
  var currency      = wrapper.dataset.currency || 'USD';

  function fmt(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2
    }).format(cents / 100);
  }

  function getVariant(id) {
    return productData ? productData.variants.find(function (v) { return v.id == id; }) : null;
  }

  /* ── Update CTA button price ── */
  function updateCtaPrice(currentPrice) {
    var el = wrapper.querySelector('[data-ctr-btn-price]');
    if (el) el.textContent = '| ' + fmt(currentPrice);
  }

  /* ── Purchase mode (section variant ID lists) ── */
  function parsePurchaseModeIds(root, attr) {
    if (!root) return [];
    var raw = (root.getAttribute(attr) || '').trim();
    if (!raw || raw === '[]') return [];
    if (raw.charAt(0) === '[') {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed.map(String);
      } catch (e) {}
    }
    return raw.split(/[\s,]+/).filter(Boolean);
  }

  function getPurchaseMode(variantId) {
    var root = wrapper.closest('[data-purchase-mode]') || document.querySelector('[data-purchase-mode]');
    var id = String(variantId || '');
    if (parsePurchaseModeIds(root, 'data-subscription-only-ids').indexOf(id) !== -1) {
      return 'subscription_only';
    }
    if (parsePurchaseModeIds(root, 'data-otp-only-ids').indexOf(id) !== -1) {
      return 'otp_only';
    }
    return 'both';
  }

  function applyPurchaseMode(variantId) {
    var onceWrap = wrapper.querySelector('.ctr-buy-button__buy-once-wrapper');
    if (!onceWrap) return;
    onceWrap.hidden = getPurchaseMode(variantId) === 'subscription_only';
  }

  /* ── Update buy-once button prices ── */
  function updateBuyOnce(variant) {
    if (!buyOnceBtn || !variant) return;
    var priceEl   = wrapper.querySelector('[data-ctr-buy-once-price]');
    var compareEl = wrapper.querySelector('[data-ctr-buy-once-compare]');

    if (priceEl) priceEl.textContent = fmt(variant.price);

    if (compareEl) {
      if (variant.compare_at_price) {
        compareEl.textContent = fmt(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
  }

  /* ══════════════════════════════════════════════
     LISTEN FOR ctr:price-update (from ctr-price-new.js)
     ══════════════════════════════════════════════ */
  document.addEventListener('ctr:price-update', function (e) {
    var d = e.detail;
    if (!d) return;
    updateCtaPrice(d.currentPrice);
    updateBuyOnce(d.variant);
    if (d.variant && d.variant.id) applyPurchaseMode(d.variant.id);
  });

  /* ── Helpers for subscription-aware pricing ── */
  function isSub() {
    var el = document.querySelector('[data-purchase-option][value="subscription"]');
    return el && el.checked;
  }

  function getSubPrice(v) {
    if (!v) return v ? v.price : 0;
    if (isSub() && v.selling_plan_allocations && v.selling_plan_allocations.length) {
      var alloc = v.selling_plan_allocations[0];
      if (alloc && alloc.price) return alloc.price;
    }
    return v.price;
  }

  /* ── Fallback: variant input observer (if ctr-price-new.js is absent) ── */
  var form = document.querySelector('[data-type="add-to-cart-form"]');
  var variantInput = form ? form.querySelector('input[name="id"]') : null;

  if (variantInput) {
    var lastId = variantInput.value;

    function fallbackUpdate(id) {
      var v = getVariant(id);
      if (!v) return;
      updateCtaPrice(getSubPrice(v));
      updateBuyOnce(v);
      applyPurchaseMode(id);
    }

    new MutationObserver(function () {
      if (variantInput.value && variantInput.value !== lastId) {
        lastId = variantInput.value;
        fallbackUpdate(lastId);
      }
    }).observe(variantInput, { attributes: true, attributeFilter: ['value'] });

    variantInput.addEventListener('change', function () {
      if (this.value && this.value !== lastId) {
        lastId = this.value;
        fallbackUpdate(lastId);
      }
    });
  }

  /* ══════════════════════════════════════════════
     BUY-ONCE CLICK HANDLER
     ══════════════════════════════════════════════ */
  if (buyOnceBtn) {
    buyOnceBtn.addEventListener('click', function (e) {
      e.preventDefault();

      var cartForm = document.querySelector('[data-type="add-to-cart-form"]');
      if (!cartForm) return;

      var variantId = cartForm.querySelector('input[name="id"]');
      if (!variantId || !variantId.value) return;
      if (getPurchaseMode(variantId.value) === 'subscription_only') return;

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var productFormEl = wrapper.querySelector('ctr-product-form');
      var atcBehavior = (productFormEl && productFormEl.dataset.atcBehavior) || 'cart_drawer';

      buyOnceBtn.classList.add('loading');
      buyOnceBtn.setAttribute('aria-disabled', true);
      var spinner = buyOnceBtn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      var prepare =
        atcBehavior === 'direct_checkout' && typeof window.ctrBeginDirectCheckout === 'function'
          ? window.ctrBeginDirectCheckout()
          : Promise.resolve();

      prepare
        .catch(function () { return null; })
        .then(function () {
          var config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          var formData = new FormData();
          formData.append('id', variantId.value);
          formData.append('quantity', 1);

          if (cart && cart.getSectionsToRender) {
            formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
            formData.append('sections_url', window.location.pathname);
            cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          return fetch(routes.cart_add_url, config)
            .then(function (r) { return r.json(); })
            .then(function (response) {
              if (response.status) {
                console.error('Add to cart failed:', response);
                alert(response.description || 'Could not add to cart');
                return;
              }
              if (atcBehavior === 'direct_checkout') {
                if (typeof window.ctrGoToCheckout === 'function') {
                  window.ctrGoToCheckout();
                } else {
                  window.location.href = '/checkout';
                }
                return;
              }
              if (!cart) {
                window.location = window.routes.cart_url;
                return;
              }
              if (typeof publish !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'ctr-buy-button',
                  productVariantId: variantId.value,
                  cartData: response
                });
              }
              if (typeof CartPerformance !== 'undefined') {
                CartPerformance.measure('add:paint-updated-sections', function () {
                  cart.renderContents(response);
                });
              } else {
                cart.renderContents(response);
              }
            });
        })
        .catch(function (err) {
          console.error('Add to cart error:', err);
        })
        .finally(function () {
          buyOnceBtn.classList.remove('loading');
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          buyOnceBtn.removeAttribute('aria-disabled');
          var s = buyOnceBtn.querySelector('.loading__spinner');
          if (s) s.classList.add('hidden');
        });
    });
  }

  /* ── Initial price sync (subscription-aware) ── */
  function initialSync() {
    var id = variantInput ? variantInput.value : null;
    if (!id) return;
    var v = getVariant(id);
    if (!v) return;
    updateCtaPrice(getSubPrice(v));
    updateBuyOnce(v);
    applyPurchaseMode(id);
  }
  initialSync();
  setTimeout(initialSync, 600);
})();
